module.exports = __webpack_public_path__ + "static/media/ios-partly-sunny.a3ff3d09.svg";